/**
  * @func formatDateOfBirth
  * @author Brian Nunez <brian.j.nunez1@aexp.com>
  * @param {string} dateOfBirth - The date of birth in the format of 'DD.MM.YYYY'
  * @returns {string} - The date of birth in the format of 'YYYYMMDD'
*/
function formatDateOfBirth(dateOfBirth) {
  return dateOfBirth?.split('.')?.reverse()?.join('');
}

export default formatDateOfBirth;
